import { render, staticRenderFns } from "./ResultsDashboard.vue?vue&type=template&id=84cf1e1a"
import script from "./ResultsDashboard.vue?vue&type=script&lang=js"
export * from "./ResultsDashboard.vue?vue&type=script&lang=js"
import style0 from "./ResultsDashboard.vue?vue&type=style&index=0&id=84cf1e1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports